import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss']
})
export class ShowcaseComponent implements OnInit {

  /* ── LEGACY CAROUSEL CODE (COMMENTED OUT) ─────────────
  isLoading: boolean[] = [];
  slider: { title: string, imgUrl: string }[] = [
    {
      title: 'A Legacy of Service',
      imgUrl: '/assets/img/showcase/1.jpg'
    },
    {
      title: 'Vision is everything',
      imgUrl: '/assets/img/showcase/2.jpg'
    },
    {
      title: 'Innovation. Education. Success.',
      imgUrl: '/assets/img/showcase/3.jpg'
    },
    {
      title: 'Life is all about having a good time',
      imgUrl: '/assets/img/showcase/4.jpg'
    },
    {
      title: 'The Future Awaits',
      imgUrl: '/assets/img/showcase/5.jpg'
    },
    {
      title: 'We raise leaders for the future ',
      imgUrl: '/assets/img/showcase/6.jpg'
    }
  ];

  setLoader() {
    for (let i = 0; i < this.slider.length; i++) {
      this.isLoading.push(true);
    }
  }

  hideLoader(i: number) {
    this.isLoading[i] = false;
  }
  ────────────────────────────────────────────────────── */

  isPlaying = true;
  isMuted = true;

  constructor() { }

  ngOnInit(): void {
    /* ── LEGACY CAROUSEL INIT (COMMENTED OUT) ───────────
    this.setLoader();
    $('.carousel').carousel({
      pause: false
    });
    ────────────────────────────────────────────────────── */
  }

  togglePlay(video: HTMLVideoElement): void {
    if (this.isPlaying) {
      video.pause();
    } else {
      video.play().catch(err => console.log('Video play failed:', err));
    }
    this.isPlaying = !this.isPlaying;
  }

  toggleMute(video: HTMLVideoElement): void {
    this.isMuted = !this.isMuted;
    video.muted = this.isMuted;
  }

}

